export const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/tWvnvD9LkEsXVvP5LV1AUm/Mockup_PMU.png'

export const MOCKUP_ALT =
  'PMU Instructor Ready™ — six pastel teaching volumes with interior pages shown on a tablet, laptop and phone'
